package oldcomponents.rules

import bootstrap.Dropdown
import bootstrap.DropdownItem
import bootstrap.DropdownMenu
import bootstrap.DropdownToggle
import kotlinx.css.zIndex

import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLInputElement
import react.*
import react.dom.*
import react.dom.onChange
import ru.it_mozaika.sender.common.models.Rule
import styled.css
import styled.styledDiv


external interface RuleGroupProps : RuleProps<Rule.RuleGroup> {
    var campaigns: Map<String, String>
    var staticSegments: Map<String, String>
    var dynamicSegments: Map<String, String>
    var subscriptionLists: Map<String, String>
}

val ruleGroup = fc<RuleGroupProps> { props ->
    renderRuleGroup(props)
}

private fun RBuilder.renderRuleGroup(props: RuleGroupProps) {

    var andRuleOperator by useState(props.item.andRuleOperator)
    var rules by useState(props.item.rules)
    var groupId by useState("")
    useEffect(props.item) {
        rules = props.item.rules
        andRuleOperator = props.item.andRuleOperator
    }
    useEffect(props.id) { groupId = if (undefined != props.id) props.id else "0" }

    var dropdownOpen by useState(false)

    fun onRemoveRule(rule: Rule) { props.onChange(props.item.copy(rules = rules.minus(rule))) }
    fun onChangeRule(index: Int, rule: Rule) {
        val result = rules.toMutableList()
        result[index] = rule
        props.onChange(props.item.copy(rules = result))
    }

    div("form-group row d-flex align-items-baseline pr-3 mt-2") {
        label("col-3 form-control-label") { +"Необходимо выполнение условий:" }
        div("col-3 row d-flex") {
            div("custom-control custom-radio styled-radio mb-3 mr-3") {
                input(InputType.radio, name = "opt-all-${props.id}", classes = "custom-control-input") {
                    attrs {
                        id = "opt-all-${props.id}"
                        required = true
                        attrs["checked"] = andRuleOperator
                        onChange = {
                            (it.target as? HTMLInputElement)?.checked?.let { v ->
                                props.onChange(props.item.copy(andRuleOperator = true))
                            }
                        }
                    }
                }
                label(classes = "custom-control-descfeedback") {
                    attrs["htmlFor"] = "opt-all-${props.id}"
                    +"Всех"
                }
            }
            div("custom-control custom-radio styled-radio mb-3") {
                input(InputType.radio, name = "opt-any-${props.id}", classes = "custom-control-input") {
                    attrs {
                        id = "opt-any-${props.id}"
                        required = true
                        attrs["checked"] = !andRuleOperator
                        onChange = {
                            (it.target as? HTMLInputElement)?.checked?.let { v ->
                                props.onChange(props.item.copy(andRuleOperator = false))
                            }
                        }
//                        attrs.onChangeFunction = {
//                            if ((it.currentTarget as? HTMLInputElement)?.checked == true) {
//                                println("any checked")
//                                props.onChange(props.item.copy(andRuleOperator = false))
//                            }
////                            props.onChange(props.item.copy(andRuleOperator = (it.currentTarget as? HTMLInputElement)?.checked == false))
//                        }
                    }
                }
                label(classes = "custom-control-descfeedback") {
                    attrs["htmlFor"] = "opt-any-${props.id}"
                    +"Любого"
                }
            }
        }
        div("col-5 row d-flex") {
            Dropdown {
                attrs.onToggle = { isOpen, _, metadata ->
//                    if (isOpen || (undefined != metadata && undefined != metadata.source && metadata.source != "select")) {
                        dropdownOpen = isOpen
//                    }
                }
                attrs.show = dropdownOpen
                DropdownToggle {
                    attrs.`as` = forwardRef<BUTTON, PropsWithRef<BUTTON>> { p, rRef ->
                        button(type = ButtonType.button) {
                            ref = rRef
                            attrs.classes = attrs.classes.plus("btn btn-outline-primary btn-sm")
                            attrs.onClickFunction = {
                                dropdownOpen = !dropdownOpen
//                                props.onChange(props.item.copy(rules = rules.plus(Rule.RuleGroup())))
                            }
                            i("la la-plus-circle") {}
                            +"Добавить"
                        }
                    }
                }
                DropdownMenu {
                    attrs.show = dropdownOpen
                    attrs.`as` = forwardRef<DIV, PropsWithRef<DIV>> { p, rRef ->
                        styledDiv {
                            css {
                                p.unsafeCast<PropsWithClassName>().className?.let {
                                    classes.add(it.toString())
                                }
                                zIndex = 100
                            }
                            ref = rRef
                            listOf(
                                "group" to "Группа",
                                "segment" to "Сегмент",
                                "campaign" to "Массовая рассылка",
                                "subscribe" to "Дата подписки",
                            ).forEach { (key, name) ->
                                DropdownItem {
                                    attrs.eventKey = key
                                    attrs.onClick = {
                                        when (key) {
                                            "group" -> Rule.RuleGroup()
                                            "segment" -> Rule.Segment()
                                            "campaign" -> Rule.EmailCampaign()
//                                            "subscribe" -> Rule.SubscribeDate()
                                            else -> null
                                        }?.let { newRule -> props.onChange(props.item.copy(rules = rules.plus(newRule))) }
                                    }
                                    +name
                                }
                            }
                        }
                    }
                }
            }
            if (undefined != props.onRemove) {
                button(type = ButtonType.button, classes = "btn btn-outline-danger btn-sm") {
                    attrs.onClickFunction = {
                        props.onRemove()
                    }
                    i("la la-trash") {}
                    +"Удалить"
                }
            }
        }
    }
    div("col-12 ml-2") {
        div("em-separator separator-dashed m-2") {}
        rules.forEachIndexed { index, rule ->
            when (rule) {
                is Rule.RuleGroup -> ruleGroup {
                    attrs {
                        id = "$groupId.$index"
                        item = rule
                        campaigns = props.campaigns
                        staticSegments = props.staticSegments
                        dynamicSegments = props.dynamicSegments
                        subscriptionLists = props.subscriptionLists
                        onRemove = { onRemoveRule(rule) }
                        onChange = { onChangeRule(index, it) }
                    }
                }
                is Rule.Segment -> segmentRule {
                    attrs {
                        id = "$groupId.$index"
                        staticSegments = props.staticSegments
                        dynamicSegments = props.dynamicSegments
                        item = rule
                        onRemove = { onRemoveRule(rule) }
                        onChange = { onChangeRule(index, it) }
                    }
                }
                is Rule.EmailCampaign -> emailCampaignRule {
                    attrs {
                        id = "$groupId.$index"
                        campaigns = props.campaigns
                        item = rule
                        onRemove = { onRemoveRule(rule) }
                        onChange = { onChangeRule(index, it) }
                    }
                }
                is Rule.SubscribeDate -> subscribeDateRule {
                    attrs {
                        id = "$groupId.$index"
                        subscriptionLists = props.subscriptionLists
                        item = rule
                        onRemove = { onRemoveRule(rule) }
                        onChange = { onChangeRule(index, it) }
                    }
                }
                else -> null
            }
        }
        div("em-separator separator-dashed m-2") {}
    }
}
